import React from "react";
import "./Footer.scss";

import { useNavigate } from "react-router-dom";

import classNames from "classnames";
import _ from "lodash";

import parse from "html-react-parser";

const COPYRIGHT_TEXT = "Copyright 2022, Workoza Inc. All Rights Reserved.";
const POWERED_BY_TEXT = "Powered By: Workoza pvt Limited";

const FOOTER_ROUTES = [
  {
    id: "SERVICES",
    label: "Services",
    child: [
      {
        id: "software_development",
        label: "Software Development",
        route: "services/software-development",
      },
      {
        id: "project_management",
        label: "Project Management",
        route: "services/project-management",
      },
      {
        id: "data_analyst",
        label: "Data & Analytics",
        route: "services/data-analyst",
      },
      {
        id: "quality_assurance",
        label: "Quality Assurance",
        route: "services/quality-assurance",
      },
    ],
  },
  {
    id: "CAREERS",
    label: "Careers",
    child: [
      {
        id: "career_center",
        label: "Career Center",
        route: "careers",
      },
    ],
  },
  {
    id: "ABOUT_US",
    label: "About us",
    child: [
      {
        id: "about_company",
        label: "Company",
        route: "about-us/our-company",
      },
    ],
  },
  {
    id: "CONTACT_US",
    label: "Contact us",
    child: [
      // {
      //   id: "phone_number",
      //   label: "India: +91 9979621919",
      // },
      {
        id: "email",
        label: "Email: workoza.info@gmail.com",
      },
      {
        id: "address",
        label: "Address: 21D Sienna st, Kitchener,",
      },
      {
        id: "address2",
        label:
          "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ON N2R 0H9",
      },
    ],
  },
];

const Footer = () => {
  const navigate = useNavigate();

  const handleFooterLogoClick = () => {
    navigate("/");
  };

  const renderFooterChild = ({ node }) => {
    const childNode = node?.child;

    return (
      <div className="footerChildContainer">
        {childNode.map(({ id, label, route }) => {
          const footerSubLabelTextClass = classNames({
            footerSubLabelText: true,
            footerSubLabelHoverText: !_.isUndefined(route),
          });

          const handleFooterRouteClick = () => {
            if (route) {
              navigate(`${route}`);
            }
          };

          return (
            <div
              className={footerSubLabelTextClass}
              key={id}
              onClick={handleFooterRouteClick}
            >
              {parse(String(label))}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <div className="footerContainer">
        <div className="footerWrapper">
          {FOOTER_ROUTES.map((node) => {
            return (
              <div className="footerEachContainer" key={node?.id}>
                <div className="footerMainLabelText">{node?.label}</div>
                {renderFooterChild({ node })}
              </div>
            );
          })}
          <div
            className="footerEachContainerLogoContainer"
            onClick={handleFooterLogoClick}
          >
            <img
              src="/workoza_logo_white.png"
              alt="no logo"
              height={40}
              width={160}
              className="footerLogoContainer"
            />
          </div>
        </div>
        <div className="footerBottomContainer">
          <div className="footerCopyRightText">&#169; {COPYRIGHT_TEXT}</div>
          <div className="footerCopyRightText">{POWERED_BY_TEXT}</div>
        </div>
      </div>
    </>
  );
};

export default Footer;
